import { WorkOrderChangeStatusEnum } from 'gql/graphql';
import type { IUseAccess } from 'hooks/useAccess';
import { Button, Tooltip } from 'uikit';

import { useCallback, useMemo, useRef, useState } from 'react';

import { WorkOrderChapters } from '../../WorkOrder/workorderTypes';
import { AddUerToWorkOrderChangeTable } from '../AddUerToWorkOrderChangeTable';
import type { TFilters } from '../WorkOrderChange';

type TAddUerProps = {
    workOrderChangeObjectId?: number;
    chapter: any;
    constructionTypeId: number;
    refreshTable: () => void;
    contractId: any;
    isActionsDisabled: boolean;
    filters: TFilters;
    workOrderChangeStatus?: WorkOrderChangeStatusEnum;
    workOrderChangeUerRules: IUseAccess['workOrderChangeUer'];
    withBtn?: boolean;
    workOrderChangeId: number;
    workOrderObjectId: number;
    catalogUerBaseName: string;
    catalogVersion: string;
} & (
    | {
          isModalOpenedOuter: boolean;
          closeModalOuter: () => void;
      }
    | {
          isModalOpenedOuter?: never;
          closeModalOuter?: never;
      }
);

export const AddUerToWorkOrderChange = ({
    isModalOpenedOuter,
    closeModalOuter,
    workOrderChangeObjectId,
    chapter,
    filters,
    constructionTypeId,
    refreshTable,
    contractId,
    isActionsDisabled,
    workOrderChangeStatus,
    workOrderChangeUerRules,
    withBtn = false,
    workOrderChangeId,
    workOrderObjectId,
    catalogUerBaseName,
    catalogVersion,
}: TAddUerProps) => {
    const refButton = useRef(null);

    const [isModalOpened, setIsModalOpened] = useState(false);
    const [isOpenTooltip, setIsOpenTooltip] = useState<boolean>(false);

    const workOrderChangeStatusOnFormation = workOrderChangeStatus === WorkOrderChangeStatusEnum.OnFormation;

    const isBtnDisabled = useMemo(() => !workOrderChangeObjectId || !chapter, [chapter, workOrderChangeObjectId]);

    const openModalHandler = useCallback(() => {
        setIsModalOpened(true);
    }, []);

    const closeModalHandler = useCallback(() => {
        setIsModalOpened(false);
        if (isModalOpenedOuter) {
            closeModalOuter?.();
        }
    }, [closeModalOuter, isModalOpenedOuter]);

    const handleMouseMoveButton = useCallback(() => {
        if (
            workOrderChangeStatusOnFormation &&
            filters?.chapter !== WorkOrderChapters.OTHERS &&
            (!filters?.chapter || !filters?.objectId || !filters?.subObjectId)
        ) {
            setIsOpenTooltip(true);
        }
    }, [filters?.chapter, filters?.objectId, filters?.subObjectId, workOrderChangeStatusOnFormation]);

    const handleMouseLeaveButton = useCallback(() => {
        setIsOpenTooltip(false);
    }, []);

    return (
        <>
            {withBtn && (
                <div
                    ref={refButton}
                    onMouseMove={handleMouseMoveButton}
                    onMouseLeave={handleMouseLeaveButton}
                    style={{ display: 'inline-block', marginRight: '16px' }}
                >
                    <Button
                        label="Добавить расценку"
                        size="s"
                        view="secondary"
                        onClick={openModalHandler}
                        disabled={isBtnDisabled || isActionsDisabled}
                    />
                </div>
            )}
            {isOpenTooltip && (
                <Tooltip size="s" direction="upCenter" anchorRef={refButton} isInteractive={false}>
                    Выберите раздел, объект и подобъект
                </Tooltip>
            )}
            {(isModalOpenedOuter || isModalOpened) && (workOrderChangeObjectId || workOrderObjectId) && chapter && (
                <AddUerToWorkOrderChangeTable
                    workOrderObjectId={workOrderObjectId}
                    workOrderChangeId={workOrderChangeId}
                    workOrderChangeObjectId={workOrderChangeObjectId}
                    chapter={chapter}
                    constructionTypeId={constructionTypeId}
                    handleClose={closeModalHandler}
                    refreshTable={refreshTable}
                    contractId={contractId}
                    workOrderChangeUerRules={workOrderChangeUerRules}
                    catalogUerBaseName={catalogUerBaseName}
                    catalogVersion={catalogVersion}
                />
            )}
        </>
    );
};

AddUerToWorkOrderChange.displayName = 'AddUerToWorkOrderChange';
